import { render, staticRenderFns } from "./SpringerAuth.vue?vue&type=template&id=52d584e2&scoped=true&"
import script from "./SpringerAuth.vue?vue&type=script&lang=js&"
export * from "./SpringerAuth.vue?vue&type=script&lang=js&"
import style0 from "./SpringerAuth.vue?vue&type=style&index=0&id=52d584e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d584e2",
  null
  
)

export default component.exports